import styled from 'styled-components';
import { themeGet, getBackgroundColor } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
export const Wrapper = styled.div`
  background-color: ${props => props.isTransparent ? 'transparent' : getBackgroundColor('lighter')(props)};
`;
export const Container = styled(Flex)`
  position: relative;
  flex: 0;
  flex-basis: auto;
  height: 32px;
  overflow-y: hidden;
  width: max-content;
  direction: rtl;
  background-color: ${props => props.isTransparent ? 'transparent' : getBackgroundColor('lighter')(props)};
`;
export const BreadcrumbList = styled(Flex)`
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 ${props => themeGet('space.4')(props)}px 0
    ${props => themeGet('space.2')(props)}px;
  direction: ltr;
`;